import type { FreelancerSignUpLocales } from '../types';

const freelancerSignUpLocales: FreelancerSignUpLocales = {
  agreeWith: 'Ik ga akkoord met de',
  alreadyHaveAccount: 'Al een Tadaah account?',
  howDoYouKnowTadaah: 'Hoe ken je Tadaah?',
  noAccount: 'Nog geen account?',
  signupError:
    'Er is iets fout gegaan tijdens je registratie. Probeer het opnieuw of ververs de pagina.',
  signupSuccess: 'Account aangemaakt!',
  title: 'Aanmelden',
  toLogin: 'om in te loggen',
  toSignup: 'om je te melden',
  welcome: 'Welkom',
};

export default freelancerSignUpLocales;
